import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { RefreshCw } from 'lucide-react';
import { usePWA } from '@/hooks/usePWA';

export const PWAPrompt = () => {
  const { updateAvailable, updateApp } = usePWA();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !updateAvailable) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm">
      <Card className="border-primary shadow-lg animate-in slide-in-from-bottom-5">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <RefreshCw className="h-5 w-5 text-primary animate-spin" style={{ animationDuration: '3s' }} />
            <div className="flex-1">
              <h4 className="font-semibold text-sm">Actualización Disponible</h4>
              <p className="text-xs text-muted-foreground">
                Haz clic en Actualizar para aplicar los cambios
              </p>
            </div>
            <Button 
              size="sm" 
              onClick={updateApp}
              className="bg-primary hover:bg-primary/90"
            >
              Actualizar
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};